/**
 * @generated SignedSource<<57aa0d7a21aa8a4cf07941b81c5ffba0>>
 * @relayHash b284f67f1f656435d82e16aa401fb7e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 507ca052fcb589da5c9b26c9f675c8eb132b3e37eae53f299dad3bee8ac6a7c4

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type IssueRealtimeUpdatesOld_issueCreatedSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type IssueRealtimeUpdatesOld_issueCreatedSubscription$data = {
  readonly jira: {
    readonly onIssueCreatedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type IssueRealtimeUpdatesOld_issueCreatedSubscription = {
  response: IssueRealtimeUpdatesOld_issueCreatedSubscription$data;
  variables: IssueRealtimeUpdatesOld_issueCreatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueCreatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueCreatedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "IssueRealtimeUpdatesOld_issueCreatedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueRealtimeUpdatesOld_issueCreatedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "507ca052fcb589da5c9b26c9f675c8eb132b3e37eae53f299dad3bee8ac6a7c4",
    "metadata": {},
    "name": "IssueRealtimeUpdatesOld_issueCreatedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "b15cdab36914d0d913c7f692d88fbcd1";

export default node;
